import {FormControl, FormGroup, Validators } from "@angular/forms";

export type RefreshmentTimeSection = {
  id: string;
  name: string;
  completed: boolean;
  fields: Array<{
    id: string;
    name: string;
    linkHREF?: string;
    linkText?: string;
    type: string;
    value: any;
    mandatory: boolean;
    readOnly: boolean;
    dependencies: Array<{
      fieldID: string;
      sectionID: string;
      type: string;
      value: any;
    }>;
    validators: Array<{
      name: string;
      options: any;
    }>;
    addedValidators?: Validators[];
    visibility: boolean;
    currentVisibility?: boolean;
  }>
};

export class CreateRefreshmentTimeForms {
  private userData: RefreshmentTimeSection[];
  private allForms: { [key: string]: FormGroup } = {};
  private sectionNames: string[] = [];

  constructor(userData: RefreshmentTimeSection[]) {
    this.userData = userData;
  }

  private dropdownValidator(options: any): any {
    return (control: FormControl) => {
      if (control.value === null || control.value === undefined || control.value === '') {
        return null; // Let required validator handle empty values
      }
      const valid = options.some(option => option.value === control.value);
      return valid ? null : { invalidDropdown: true};
    }
  }

  private requiredDropdownValidator(): any {
    return (control: FormControl) => {
      if (control.value === null || control.value === undefined || control.value === '') {
        return { requiredField: true };
      }
      return null;
    };
  }

  createForms(): {
    fields: Array<{ id: string; fields: any[]; values: any[] }>,
    forms: { [key: string]: FormGroup },
    names: string[]
  } {
    const fields: Array<{ id: string; fields: any[]; values: any[] }> = [];

    this.userData.forEach((section: RefreshmentTimeSection) => {
      const id = section.id;

      const sectionFields = section.fields.map((field: any) => ({
        id: field.id,
        name: field.name,
        validators: field.validators,
        value: field.value,
        type: field.type,
        mandatory: field.mandatory,
        readOnly: field.readOnly,
        dependencies: field.dependencies,
        currentVisibility: field.visibility,
        tooltip: field.tooltip,
        addedValidators: field.addedValidators

      }));

      this.sectionNames.push(section.name);

      fields.push({ id, fields: sectionFields, values: [] });
      
      const formName = section.id;
      this.allForms[formName] = new FormGroup({});

      sectionFields.forEach(field => {

        let fieldVal;
        fieldVal = field.value;

        this.allForms[formName].addControl(field.id, new FormControl(fieldVal));
        let CONTROL = this.allForms[formName].controls[field.id];

        let controlValidators = [];

        if (field.mandatory) {
          controlValidators.push(Validators.required);
        }

        field.validators.forEach(validator => {
          if (validator.name === 'inputLength') {
            const min = validator.options.minimum;
            const max = validator.options.maximum;
            controlValidators.push(Validators.minLength(min), Validators.maxLength(max));
          }

          if (validator.name === 'regex') {
            const expression = validator.options.expression;
            controlValidators.push(Validators.pattern(expression));
          }

          if (validator.name === 'inputEmpty') {
            const expression = validator.options.expression;
            controlValidators.push(Validators.pattern(expression));
          }

          if (validator.name === 'dropdown' && field.id != 'WorkCity') {
            controlValidators.push(Validators.required);
            controlValidators.push(this.dropdownValidator(validator.options));
            controlValidators.push(this.requiredDropdownValidator());
          }

        });
        CONTROL.setValidators(controlValidators);
        field.addedValidators = controlValidators;
        CONTROL.updateValueAndValidity();
      });
    });
    return{
      fields,
      forms: this.allForms,
      names: this.sectionNames
    };
  }
}